import React from 'react'

const TablaConsolidadoEstados = () => {
  return (
    <div>TablaConsolidadoEstados</div>
  )
}

export default TablaConsolidadoEstados